import { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function RowRadioButtonsGroup({value, setValue, setError, handleNext, currentIndex, totalQuestions, options = [], params, is_sample = false, ...rest}) {
    const [isValueChange, setIsValueChange] = useState(false)

    const handleChange = (event) => {
        setValue(event.target.value)
        setError(true)
        // setIsValueChange(true)
    };

    // useEffect(() => {
    //     if(isValueChange && currentIndex < totalQuestions-1 ){
    //         handleNext()
    //     }
    //     setIsValueChange(false)      
    // }, [isValueChange])

    return (
        <RadioGroup
            // row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value || null}
            onChange={handleChange}
        >
            {[
                ...options.slice(1).map((label, index) => ({
                    label,
                    originalIndex: index + 1
                })),
                ...(options.length > 0
                    ? [{ label: options[0], originalIndex: 0 }]
                    : [])
            ].map(({ label, originalIndex }) => {

                // If raterId does not exist, don't show first option
                if (!params?.raterId && originalIndex === 0 && !is_sample) {
                    return null;
                }

                return (
                    <FormControlLabel
                        key={originalIndex}
                        value={originalIndex.toString()}
                        control={<Radio />}
                        label={label}
                    />
                );
            })}
            {/* {options.map((label, index) => (
                <FormControlLabel
                    key={index}
                    value={index.toString()}
                    control={<Radio />}
                    label={label}
                />
            ))} */}
            {/* <FormControlLabel value="0" control={<Radio />} label="Not Observed" />
            <FormControlLabel value="1" control={<Radio />} label="Never/Rarely" />
            <FormControlLabel value="2" control={<Radio />} label="Occasionally" />
            <FormControlLabel value="3" control={<Radio />} label="Sometimes" />
            <FormControlLabel value="4" control={<Radio />} label="Often" />
            <FormControlLabel value="5" control={<Radio />} label="Always/Almost Always" />             */}
        </RadioGroup>
    );
}